import axios from 'axios';

export default {
  FETCH_PRESS ({commit, dispatch}, payload){
        return new Promise((resolve, reject) => {
            commit('TOGGLE_LOADING', true);
            // axios.post('login/authenticate', payload)
            axios.get('common/getPressPageContents')
                .then((response) => {
                    const { data: { data : { payload } } } = response;
                    localStorage.setItem('press', JSON.stringify(payload));
                    commit('SET_PRESS', payload);
                    commit('TOGGLE_LOADING', false);
                    resolve(payload);

                })
                .catch((error) => {
                    console.log('action fetch error : ', error);
                    reject(error);
                    commit('TOGGLE_LOADING', false);
                });
        })
    },
    GETSELECTEDPRESS ({ commit }, pressRoomContentId) {
        commit('TOGGLE_LOADING', true);
        return axios.get(`common/getPressPageContents`).then((response) => {
            commit('TOGGLE_LOADING', false);
            const { data: { data : { payload }} } = response;

            console.log('payload', payload)
            let selectedPress = payload.filter(x => {
              return x.pressRoomContentId.toString() === pressRoomContentId.toString()
            });
            console.log('found press', selectedPress)
            commit('SET_SELECTED_PRESS', selectedPress[0])
        }, (err) => {
            commit('TOGGLE_LOADING', false);
            console.log('err ', err)
        })
    },
    ADD_PRESS({commit, dispatch}, payload){
        return new Promise((resolve, reject) => {
            commit('TOGGLE_LOADING', true);
            console.log("add press payload : ", payload);
            axios.post('common/insertPressPageContents', payload)
                .then((response) => {
                    console.log('ADD_PRESS action fetch response : ', response);
                    const { data: { data } } = response;
                    commit('TOGGLE_LOADING', false);
                    resolve(data);
                })
                .catch((error) => {
                    console.log('ADD_PRESS action fetch error : ', error);
                    reject(error);
                    commit('TOGGLE_LOADING', false);
                });
        })
    },
  UPDATE_PRESSRELEASE({commit, dispatch}, payload){
      console.log('payload to update', payload)
        return new Promise((resolve, reject) => {
            commit('TOGGLE_LOADING', true);
            axios.post('/common/updatePressPageContents', payload)
                .then((response) => {
                    const { data: { data } } = response;
                    commit('TOGGLE_LOADING', false);
                    resolve(data);
                })
                .catch((error) => {
                    console.log('UPDATE_PRESS action fetch error : ', error);
                    reject(error);
                    commit('TOGGLE_LOADING', false);
                });
        })
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/press/actions.js